export const themes = {
    light: {
        colors: {
            text: '#333',
            background: {
                _: '#ffffff',
                content: '#f6f5f4',
                appicon: '#fff',
                headerbar: 'rgba(221, 217, 214, .97)',
                blurredheaderbar: 'rgba(221, 217, 214, .9)',
                button: '#f0eeec',
            },
            border: '#bfb8b1',
        }
    },
    dark: {
        colors: {
            text: '#959594',
            background: {
                _: '#353535',
                content: '#303030',
                appicon: '#fff',
                headerbar: 'hsla(0, 0%, 15%, .99)',
                blurredheaderbar: 'hsla(0, 0%, 15%, .95)',
                button: '#353535'
            },
            border: '#000',
        }
    }
}